<template>
  <header class="main-header">
    <span class="logo-mini header_logo">
      <router-link :to="{ name: 'dashboard' }">
        <a href="/">
         <img src="/static/img/applogo.png" class="appdestopview">
         <img src="/static/img/applogomob.png" class="mobileview">
         
        </a>
      </router-link>
    </span>
    <!-- Header Navbar -->

    <nav class="navbar navbar-static-top" role="navigation">
      <!-- Sidebar toggle button-->
      <span style="width:16%">
        <a
          href="javascript:;"
          class="sidebar-toggle"
          data-toggle="push-menu"
          role="button"
        >
          <span class="sr-only">Toggle navigation</span>
        </a>
      </span>
      <span class="logo-mini col-xs-8 wastea_main_heading" style="text-align:center">
        <b>
          <h2
            class=" logo1"
            style="margin-bottom: 12px;font-size: 22px;color:#0f6940;font-weight: 900;margin-top: 12px;margin-left: 65px;"
          >
            WASTE MANAGEMENT SYSTEM
          </h2>
        </b>
        <h2
          class="logo3 "
          style="margin-bottom: 1px;font-size: 22px;color: #0f6940;font-weight: 900;margin-top: 13px"
        >
          WASTE MANAGEMENT SYSTEM
        </h2>
      </span>

      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu custom_menu_wrp">
        <multiselect v-if="this.adminCheck =='superAdmin'"  v-model="$store.state.auth.cityId" class="multiSelectMargin" deselect-label="" track-by="value" label="name" placeholder="Select city" :options="cityList" :searchable="true" @select="onCitySelect" :allow-empty="false"></multiselect>
        <button v-if="user.role.key == 'superAdmin'" class="btn gradientbt1 gradientbt syncWithTraccar" @click="syncWithTraccar">
          Sync With Traccar
            </button>        
        <ul class="nav navbar-nav navW" style="float: right;">
          <!-- User Account Menu -->
          <li class="dropdown user user-menu">
            <!-- Menu Toggle Button -->
           

            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
             
              <i class="fa fa-map-marker" aria-hidden="true">
                <b>
                  {{
                    user.role.key == "superAdmin" ? null : user.cityId.cityName
                  }}
                </b>
              </i>
              <span class="hidden-xs"
                >{{ user.firstName }} {{ user.lastName }}</span
              >
            </a>
            <ul class="dropdown-menu header_dropdown">
              <!-- The user image in the menu -->
              <li class="user-header">
                <p>
                  {{ user.firstName }} {{ user.lastName }} - {{ user.roleName }}
                  <small
                    >Member since
                    {{ user.createdAt | moment("MMMM, YYYY") }}</small
                  >
                </p>
              </li>
              <!-- Menu Footer-->
              <div class="user_footer_wrp">
                <li
                  class="user-footer"
                  style="display:flex; justify-content:space-between;"
                >
                  <div class="pull-left">
                    <router-link to="/profile">
                      <a href="#" class="btn btn-default btn-flat">Profile</a>
                    </router-link>
                  </div>
                  <div class="pull-right">
                    <a href="#" @click="logout" class="btn btn-default btn-flat"
                      >Log out</a
                    >
                  </div>
                </li>
              </div>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
    <!-- <notifications></notifications> -->
  </header>
</template>

<script>
import {
    formService,
    syncWithTraccarService
} from "../../../services";
import {
        Event
    } from "vue-tables-2";
import {
    Multiselect
} from "vue-multiselect";
import {
    dashboardService
} from "../../../services";
import { mapState } from "vuex";
import { authService, eventBus } from "../../../services";
import { EVENTS, CHAT_TYPES } from "../../../config";
import Notifications from "../../utilities/Notifications.vue";
import swal from "sweetalert2";
import { cityService } from "../../../services";

export default {
  name: "MainHeader",
  components: {
        Multiselect,
  },
  userList: false,
  props: ["displayName", "pictureUrl"],
  data() {
    return {
      ready: false,
      cityList: [],
      city: "",
      adminCheck:{},
      loading: false,
      CHAT_TYPES: CHAT_TYPES,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      userInfo: (state) => state.userInfo,
      conversations: (state) => state.conversations,
    }),
  },
  methods: {

    syncWithTraccar() {
      return syncWithTraccarService
                .getSyncWithTraccar(this.data)
                .then((response) => {  
                    this.flash = false;
                    if(response.data.message != 'Success'){
                    this.$snotify.success(`Syncing with Traccar Please wait...`);
                  }else{
                    this.$snotify.success(response.data.message);
                  }
                    // if(response.data.message){
                    //   this.$snotify.success(response.data.message);
                    // }                   
                })
                .catch((error) => {                   
                    if (error.data && error.data.message) {
                        this.$snotify.error(error.data.message, "Error!");
                    } else {
                        this.$snotify.error(error, "Error!");
                    }                     
                   
                });
           
        },

    logout() {
     
      this.loading = true;
      localStorage.clear();
      sessionStorage.clear();
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        var spcook = cookies[i].split("=");
        document.cookie =
          spcook[0] + "=;expires=Thu, 21 Sep 1979 00:00:01 UTC;";
      }
      // this.$router.push("/login");
      setTimeout(() => {       
          window.location.href = "/login";              
      }, 400); 
      // this.$snotify.success("User Logout", "Success!"); 
    },

    userListTooltip(users) {
      let list = "";
      for (let user of users) {
        if (list === "") {
          list = list + user.firstName + " " + user.lastName;
        } else {
          list = list + ", " + user.firstName + " " + user.lastName;
        }
      }
      return list;
    },
    getCityList() {
            const params = {};
            let cities = [];
            this.$cityRepository
                .collectionCitysList(params)
                .then((res) => {
                    this.loading = false;
                    if (res.data.response.length > 0) {
                        res.data.response.forEach((element) => {

                            if (element.status === true) {
                                cities.push({
                                    name: element.cityName.length > 25 ?
                                        element.cityName.slice(0, 25) + "..." : element.cityName,
                                    value: element._id,
                                });
                            }
                        });
                        this.cityList = cities;
                        this.city = this.cityList[0]
                        this.onCitySelect(this.city)
                        this.$store.state.auth.cityId = this.cityList[0]
                       
                    } else {
                        this.noCity = true
                    }

                })
                .catch((error) => {
                    this.loading = false;
                    console.error("cities.requestFunction-error:", error);
                    this.$snotify.error("Get cities list failed", "Error!");

                });
        },
        onCitySelect(city) {
          this.$store.state.auth.cityId  = city         
          eventBus.$emit('cityIdChanged', city);
        },
        
    goToProfile(user) {
      this.$router.push({
        name: "MemberProfile",
        params: {
          _id: user._id,
        },
        props: user,
      });
    },
    showUser() {
      swal.fire(
        {
          title: "Cities",
          // text: 'Modal with a custom image.',
          html: `<div>
                ${this.cities.map(
                  (city) => ` <button onClick="isChecked(city)">
                    <span>${city.name}</span>
                </button> <br>`
                )}
                </div>`,
          width: "400px",
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonColor: "#d33",
          closeOnConfirm: false,
        },
        function() {
          $(".confirm").attr("disabled", "disabled");
        }
      );
    },
    isChecked(data) {},
  },
  mounted(){
    this.getCityList()
  },
  created(){
    this.adminCheck = this.$store.state.auth.user.role.key;
  }

};
</script>

<style lang="scss">
.logo2 {
  display: none !important;
}

.logo3 {
  display: none !important;
}

.sidebar-collapse {
  .logo2 {
    display: block !important;
  }

  .logo1 {
    display: none;
  }

  .logo3 {
    display: block !important;
    margin-left: 200px;
  }
}

.message-list-img {
  border-radius: 50%;
  width: 40px;
  float: left;
}

.message-list-info {
  margin-left: 45px;
}

.message-list-name {
  font-weight: 600;
  display: block;
}
.navW{
  width: 100%;
}
.multiSelectMargin{
  margin-right: 10px !important;
}
.message-list-msg {
  color: #999;
}
.gradientbt{
  margin-top: 0 !important;
}
.message-list-dot {
  float: right;

  .btn-box-tool {
    color: #97a0b3;
  }

  .btn-box-tool:hover {
    color: #333;
  }
}

.message-unread {
  background-color: #f2f5fd;
}

#dropdown-messages-menu {
  width: 450px;

  .footer {
    border-top: 1px solid #eeeeee;
  }

  li {
    a.message-menu-link {
      color: cornflowerblue;

      &:hover {
        text-decoration: underline;
        background-color: inherit;
      }
    }
  }
}

#dropdown-notifications-menu {
  width: 450px;

  .footer {
    border-top: 1px solid #eeeeee;
  }

  li {
    a.message-menu-link {
      color: cornflowerblue;

      &:hover {
        text-decoration: underline;
        background-color: inherit;
      }
    }
  }
}

.menu {
  li {
    border-bottom: 1px solid #eeeeee;
  }
}

.header_logo a {
    color: #000;
    font-size: 18px;
    position: absolute;
    left: 2px;
    top: -2px;
    width: 100%;
    font-weight: 600;
}
.header_logo a img{
  max-width: 173px;
}

.skin-blue .main-header li.user-header {
  background-color: transparent;
}

.header_dropdown .navbar-nav > .user-menu > .dropdown-menu > .user-footer {
  background-color: transparent;
}

.header_dropdown .btn-default {
  background-color: transparent;
  color: #000;
  border: 0;
  border-top: 2px solid #ddd;
  width: 100%;
  text-align: left;
  font-size: 16px;
}
.custom_menu_wrp{
  display: flex;
  align-items: center;
}
.custom_menu_wrp .navbar-nav > .user-menu > .dropdown-menu > li.user-header {
  text-align: left;
  height: auto;
}

.navbar-custom-menu > .navbar-nav > li > .dropdown-menu {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  background: #fff;
  padding: 0px 10px;
}

.header_dropdown {
  position: relative;
}

.header_dropdown:before {
  position: absolute;
  content: "";
  right: 10%;
  top: -4px;
  width: 20px;
  height: 20px;
  background: #fff;
  transform: rotate(135deg);
}

.user_footer_wrp li a svg {
  width: 20px;
  height: 20px;
}
.navbar-static-top{
  display: flex;
}

.navbar-nav > .user-menu > .dropdown-menu > li.user-header > p {
  font-weight: 600;
}
.wastea_main_heading{
  padding-left: 130px;
}
.syncWithTraccar{
margin-top: 9px;
    margin-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// MainHeader.vue?64b06a6e